/**
 * Form enhancements and interactions
 * Handles tooltip initialization and form-specific UI behaviors
 */

import Tooltip from 'bootstrap/js/dist/tooltip';

/**
 * Initialize Bootstrap tooltips on elements with data-bs-toggle="tooltip"
 */
export function initTooltips() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');

    if (tooltipTriggerList.length > 0) {
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => 
            new Tooltip(tooltipTriggerEl, {
                trigger: 'hover focus',
                boundary: 'window',
                container: 'body'
            })
        );
    }
}

/**
 * Initialize all form enhancements
 */
export function initFormEnhancements() {
    initTooltips();
}

// Auto-initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    initFormEnhancements();
});
